export const CommonDCR = {
	REBALANCE_GLITCH: 'false',
	EXPENSE_RATIO: 'Expense Ratio',
	Y3_PERFORMANCE: '3-Year Performance',
	Y1_PERFORMANCE: '1-Year Performance',
	Y5_PERFORMANCE: '5-Year Performance',
	Y1_STANDARD_DEVIATION: '1-Year Historical Risk',
	Y1_TAX_COST: '1-Year Tax Cost',
	FTE_REASON_BETTER: 'Higher',
	FTE_REASON_LOWER: 'Lower',
	PORTFOLIO_TYPE_BENCHMARK_TOOLTIP: 'Benchmark',
	PORTFOLIO_TYPE_BLACKROCK_MODEL_TOOLTIP: 'Model Portfolio',
	PORTFOLIO_TYPE_ADVISOR_PORTFOLIO_TOOLTIP: 'Alternate Portfolio',
	PORTFOLIO_TYPE_ALTERNATE_PORTFOLIO_TOOLTIP: 'Advisor Portfolio',
	PORTFOLIO_TYPE_MODEL_TOOLTIP: 'Model',
	ALLOCATIONS_AS_OF_PDF: 'Allocation as of {0}'
};

export const TabViewCategory = {
	EXPOSURES_ASSETALLOCATION_TAB: 'Portfolio',
	EXPOSURES_ASSETALLOCATION_BENCHMARK_TAB: 'vs Benchmark',
	PORTFOLIO_TAB: 'Portfolio',
	BENCHMARK_TAB: 'Vs Benchmark',
	IRETIRE_INCOME_BAR_TOTAL_GOAL: 'Total Goal',
	IRETIRE_INCOME_BAR_ESSENTIAL_GOAL: 'Essential Goal'
};

// Read only key values, do not change the values, the values should be updated using DCR
export const BenchmarkOption = {
	BENCHMARK: 'Benchmark',
	SNP500: 'SNP500'
};

export const RiskAnalyticsConfig = {
	SHARPE_RATIO_3YR_TOOLTIP: '',
	SHARPE_RATIO_5YR_TOOLTIP: '',
	TOTAL_STANDARD_DEVIATION_TOOLTIP: '',
	RATES_RISK_LABEL: 'Rate Risk',
	SPREAD_RISK_LABEL: 'Credit Spread Risk',
	EQUITY_RISK_LABEL: 'Equity Market Risk',
	FX_RISK_LABEL: 'FX Risk',
	OTHER_RISK_LABEL: 'Other Risk',
	RATES_RISK_COLOUR: '#7dba39',
	SPREAD_RISK_COLOUR: '#27a1af',
	EQUITY_RISK_COLOUR: '#f5992b',
	FX_RISK_COLOUR: '#651f76',
	OTHER_RISK_COLOUR: '#ce5426',
	equity_risk: 'Equity Risk',
	fx_risk: 'FX Risk',
	other_risk: 'Other Risk',
	rates_risk: 'Rates Risk',
	spread_risk: 'Spread Risk'
};

export const DocumentsConfig = {
	QUARTERLY_ALLOCATION_LABEL: 'Quarterly Allocations & Commentary',
	QUARTERLY_FACTSHEET_LABEL: 'Quarterly Factsheet',
	MONTHLY_PERFORMANCE_LABEL: 'Monthly Performance'
};

export const DocumentsMaterialType = [
	'QUARTERLY_ALLOCATION',
	'QUARTERLY_FACTSHEET',
	'MONTHLY_PERFORMANCE',
	'ALL_ALLOCATIONS'
];

export const HoldingsComponentDCR = {
	SECURITY_EXISTS_ERROR: 'Security already exists!',
	PORTFOLIO_TYPE_ERROR: 'Portfolio type cannot be empty!',
	PORTFOLIO_NAME_ERROR: 'Portfolio name cannot be empty!',
	INVALID_WEIGHT_ERROR: 'Invalid weight!',
	CATEGORY_NOT_MATCHED_ERROR: 'This fund is categorized as a different category and will appear in that section after you apply your changes.',
	PORTFOLIO_TYPE_OPTIONS: {
		MODEL_CURRENT: 'My Model Allocation',
		CLIENT_CURRENT: 'Client Portfolio',
		BENCHMARK: 'Benchmark Portfolio',
		HYPOTHETICAL: 'Proposed Portfolio',
		SAMPLE: 'Sample',
		CLIENT_DRAFT: 'Client Draft',
		MODEL_DRAFT: 'Model Draft',
		MODEL_PORTFOLIO: 'Model Portfolio',
		'TAX-REPORT': 'List of Holdings',
		PROSPECT_PORTFOLIO: 'Prospect Portfolio',
		CLIENT_PORTFOLIO: 'Client Portfolio',
		BPAS_PORTFOLIO: 'BPAS Portfolio',
		COMPARATIVE_BENCHMARK: 'Comparative Benchmark',
		ASSET_ALLOCATION: 'Asset Allocation'
	},
	COMPARE_MODEL_OPTIONS: {
		BLK_MODEL_PORTFOLIO: 'A Model Portfolio',
		IMPORT_PARTNER_PORTFOLIOS: 'Import External Portfolio',
		MY_SAVED_PORTFOLIOS: 'One of my Saved Portfolios',
		NEW_PORTFOLIO: 'A New Portfolio',
		BASE_MODEL: 'The Base Model',
		BENCHMARK: 'A Benchmark'
	},
	EXPORT_MODEL_OPTIONS: {
		EDIT: 'Edit Original Advisor Model',
		CREATE_NEW: 'Create New Advisor Model'
	},
	NET_EXP_RATIO_TOOLTIP: 'HOLDINGS_NET_EXP_RATIO_TOOLTIP',
	EST_RISK_TOOLTIP: 'HOLDINGS_EST_RISK_TOOLTIP',
	TRAILING_YIELD_TOOLTIP: 'HOLDINGS_TRAILING_YIELD_TOOLTIP',
	GROSS_EXP_RATIO_TOOLTIP: 'HOLDINGS_GROSS_EXP_RATIO_TOOLTIP',
	YIELD_TOOLTIP: 'HOLDINGS_YIELD_TOOLTIP',
	HOLDINGS_YIELD_NET_TOOLTIP: 'HOLDINGS_YIELD_NET_TOOLTIP',
	HOLDINGS_YIELD_CUSTOM_NET_TOOLTIP: 'HOLDINGS_YIELD_CUSTOM_NET_TOOLTIP',
	MSTAR_TOOLTIP: 'Morningstar Category',
	STD_DEVIATION_DIALOG_TITLE: 'What is the Estimated Risk number?',
	STD_DEVIATION_TOOLTIP: 'Deviation TOOLTIP',
	MIXED_VEHICLE_LABEL: 'Mutual Fund/ETF',
	ETF_VEHICLE_LABEL: 'ETF only',
	SEARCH_PLACEHOLDER: 'Enter ticker or name: Mutual Funds, ETFs, stocks, etc.',
	NAME_MODEL_LABEL: 'Name your custom portfolio',
	REMOVE_FROM_COMPARE: 'Remove from Compare',
	SELECT_PORTFOLIO_TYPE: 'Select portfolio type',
	ADD_TO_COMPARE: 'Add to Compare...',
	MY_SAVED_PORTFOLIOS_TITLE: 'One of My Saved Portfolios',
	SELECT_UP_TO_TWO: 'Select up to two portfolios',
	CREATE_NEW_PORTFOLIO: 'Create new portfolio',
	ADD_TO_COMPARISON: 'Add to Comparison',
	COMPARE_TO_BASE_DESC: 'Compare your newly customized portfolio side-by-side to the base model',
	COMPARE_TO_BASE_DESC_PARTNER: 'Compare your newly customized portfolio side-by-side to your base model',
	COMPARE_TO_BASE_LABEL: 'Compare to Base',
	VIEW_CUSTOM_PORTFOLIO_DESC: 'View additional details, including performance and risk data, of your newly customized portfolio',
	VIEW_CUSTOM_PORTFOLIO_LABEL: 'View Analysis',
	CUSTOMISE_POP_UP_TITLE: 'Your portfolio has been saved successfully.',
	CUSTOMISE_POP_UP_DESC: 'You have just created and saved a new Custom Portfolio based on a Model Portfolio. Would you like to:',
	CUSTOMISE_POP_UP_DESC_PARTNER: 'You have just created and saved a new Custom Portfolio based on your Third Party Model Portfolio. Would you like to:',
	REBAL_POP_UP_TITLE: 'Changes saved successfully.',
	REBAL_POP_UP_DESC: 'Would you like to:',
	REBAL_EXPAND_LABEL: 'Expand details',
	REBAL_COLLAPSE_LABEL: 'Collapse',
	REBAL_HIDE_MODEL_COMMENTARY: 'REBAL_HIDE_MODEL_COMMENTARY',
	REBAL_HIDDEN_MODEL_COMMENTARY_TEXT: 'REBAL_HIDDEN_MODEL_COMMENTARY_TEXT',
	RETURN_TO_REBAL_DESC: 'Return to the most recent rebalance for the BlackRock base model',
	RETURN_TO_REBAL_LABEL: 'Return to Rebalance',
	EXPORT_MODEL_TITLE: 'Send to Platform',
	ASSET_CLASS_OR_BOND_SUBSTITUTION:
		`*ETF proxies are intended to represent specific asset classes as described and communicated by Envestnet.
		  In order to assign an ETF proxy to the Envestnet placeholder, the placeholder is associated with an investment category.
		  The investment category is represented by a Morningstar category if available, or an asset class sector associated with the description provided.
		  A relevant iShares product representing that investment category is then assigned by BlackRock. All Envestnet asset class placeholders that are mapped to a
		  specific Morningstar category or asset class sector are assigned the same ETF proxy. If no investment category can be reasonably determined, then the placeholder
		  will be imported as a cash position.`
};

export const ModelSelectionComponentDCR = {
	BLK_MODEL_TITLE: 'ADD TO COMPARE ',
	BLK_MODEL_SUB_TITLE: 'A BLACKROCK MODEL',
	FILTER_BY_KEYWORD: 'Filter list by keyword',
	FEATURED_MODEL_FAMILIES: 'FEATURED MODEL FAMILIES',
	OTHER_MODEL_FAMILIES: 'ADDITIONAL MODEL FAMILIES'
};

export const BrowseAllComponentDCR = {
	FILTER_BY_KEYWORD: {
		KEY: 'MODEL_SELECTION_FILTER_BY_KEYWORD',
		DEFAULT_VALUE: 'Filter list by keyword'
	},
	FEATURED_FAMILIES_HEADING: {
		KEY: 'FEATURED_FAMILIES_HEADING',
		DEFAULT_VALUE: 'Featured Model Families'
	},
	ADDITIONAL_FAMILIES_HEADING: {
		KEY: 'ADDITIONAL_FAMILIES_HEADING',
		DEFAULT_VALUE: 'Additional Model Families'
	}
};

export const ProspectusLinksDCR = {
	INTRODUCTORY_TEXT: 'Introductory text, specific copy TBD...'
};

export const PerformanceComponentDCR = {
	BENCHMARK_TOOLTIP: '',
	FUND_PERFORMANCE_TOOLTIP: ''
};

export const HeaderComponentDCR = {
	PAGE_TITLE_LABEL: 'MODEL PORTFOLIOS',
	PDF_FILE_NAME: 'PortfolioReport.pdf',
	EXCEL_FILE_NAME: 'model-portfolios-report.xlsx',
	EMAIL_PROSPECTUS_SUBJECT: 'Product Prospectus(es)',
	EMAIL_PROSPECTUS_BODY:
		'The portfolio analysis that I will be providing you must be preceded or accompanied by a current prospectus. You should read and consider' +
		' the prospectus(es) carefully before investing. Please click on the link(s) below or copy and paste the link(s) into a web browser to view the file(s).',
	BASE_URL: 'http://globaldocuments.morningstar.com/documentlibrary/dochistory.aspx?c=USA&cusip='
};

export const ExposureBreakdownDCR = {
	// TO DO: update to UPPERCASE!
	africaAndMiddleEast: 'Africa And Middle East',
	asiaDeveloped: 'Asia Developed',
	asiaEmerging: 'Asia Emerging',
	australasia: 'Australasia',
	europeDeveloped: 'Europe Developed',
	europeEmerging: 'Europe Emerging',
	japan: 'Japan',
	latinAmerica: 'Latin America',
	northAmerica: 'North America',
	unitedKingdom: 'United Kingdom',
	unitedStates: 'United States',
	basicMaterials: 'Basic Materials',
	communicationServices: 'Communication Services',
	consumerCyclical: 'Consumer Cyclical',
	consumerDefensive: 'Consumer Defensive',
	energy: 'Energy',
	financialServices: 'Financial Services',
	healthcare: 'Healthcare',
	industrials: 'Industrials',
	realEstate: 'Real Estate',
	technology: 'Technology',
	utilities: 'Utilities',
	BelowB: 'Below B',
	NotRated: 'Not Rated',
	AVG_EFF_DURATION_TOOLTIP: '',
	AVG_EFF_MATURITY_TOOLTIP: ''
};

export const SaveSubscribeDialogDCR = {
	SAVE_SUBS_DIALOG_TITLE: 'Save & Subscribe to a BlackRock Model Portfolio',
	UNSAVE_UNSUBS_DIALOG_TITLE: 'Remove & Unsubscribe',
	DELETE_DIALOG_TITLE: 'Delete Model Portfolio',
	SAVE_OPTION_LABEL: 'Save to my Portfolios',
	SAVE_OPTION_DESCRIPTION: '',
	SAVE_SUBS_OPTION_LABEL: 'Subscribe to Trade Updates',
	SAVE_SUBS_OPTION_DESCRIPTION: 'Receive trade updates by email and save to My Portfolios.',
	UNSAVE_UNSUBS_OPTION_LABEL: 'Remove & Unsubscribe',
	UNSAVE_UNSUBS_OPTION_DESCRIPTION: 'Remove from My Portfolios and unsubscribe from email updates for this portfolio.',
	DELETE_OPTION_LABEL: 'Delete from from ‘My Saved Portfolios’',
	DELETE_OPTION_DESCRIPTION: 'Delete from from ‘My Saved Portfolios’.',
	SAVE_CONFIRM_TITLE: 'Saved!',
	UNSAVE_CONFIRM_TITLE: 'Unsaved!',
	SAVE_CONFIRM_DESCRIPTION: 'You’ve saved this BlackRock Model Portfolio to My Portfolios',
	UNSAVE_CONFIRM_DESCRIPTION: 'You’ve unsaved this BlackRock Model Portfolio',
	SAVE_CONFIRM_ACTION_LABEL: 'View My Portfolios',
	SAVE_SUBS_CONFIRM_TITLE: 'Saved!',
	SAVE_SUBS_CONFIRM_DESCRIPTION: 'You\'ve saved this portfolio and will receive periodic email updates when we make allocation enhancements.',
	SAVE_SUBS_CONFIRM_ACTION_LABEL: 'View My Portfolios',
	SAVE_SUBS_RESPONSE_TITLE: 'Saved & Subscribed!',
	UNSAVE_UNSUBS_CONFIRM_TITLE: 'Unsaved & Unsubscribed!',
	UNSAVE_UNSUBS_CONFIRM_DESCRIPTION: 'You have unsaved and unsubscribed from this portfolio',
	UNSAVE_UNSUBS_CONFIRM_ACTION_LABEL: 'View My Portfolios',
	DELETE_CONFIRM_TITLE: 'Deleted!',
	DELETE_CONFIRM_DESCRIPTION: 'You have just deleted a Portfolio from your portfolio library.',
	DELETE_CONFIRM_ACTION_DESCRIPTION: 'View Saved Portfolios',
	DELETE_CONFIRM_ACTION_LABEL: 'View Your Saved Portfolios',
	UNSAVE_UNSUBS_RESPONSE_TITLE: 'Saved & Subscribed!',
	FAIL_MESSAGE_TITLE: 'Failed!',
	FAIL_MESSAGE_DESCRIPTION: 'Your action failed',
	FAIL_MESSAGE_ACTION_DESCRIPTION: 'Try refresh page',
	FAIL_MESSAGE_ACTION_LABEL: 'Refresh',
	FAIL_MESSAGE_ACTION_URL: '/view'
};

export const ErrorHandlerServiceDCR = {
	MP_COMMON_ERROR: 'Apologies, we could not process your request.',
	MP_RETRY_MESSAGE: 'Please try again.',
	MP_RETRY_LABEL: 'Retry',
	MP_UNAUTHORIZED_ERROR: 'Your session has expired.',
	MP_LOGIN_MESSAGE: 'Please sign in again.',
	MP_LOGIN_LABEL: 'Sign In',
	PE_ERROR_MESSAGE: 'Proceed to review',
	PE_ERROR_LABEL: 'Proceed to review',
	PL_ERROR_MESSAGE: 'View saved portfolios',
	PL_ERROR_LABEL: 'View saved portfolios',
	FAIL_DIALOG_HEADING: 'Failed!',
	ERROR_DEFAULT_TITLE: 'Apologies, we could not process your request.',
	ERROR_DEFAULT_DESC: 'Please try again.',
	ERROR_APP_CONFIG_TITLE: 'Apologies, we could not process your request.',
	ERROR_APP_CONFIG_DESC: 'You do not have permissions to access this tool.'
};

export const TradeRationaleDialogDCR = {
	ARTICLE:
		'<p><b>Asset Allocation:</b> We continue to prefer risk assets and remain overweight equity exposure relative to fixed income across the portfolios. ' +
		'Sustained economic expansion, relatively attractive risk premium versus bonds and strong corporate earnings growth reinforce our conviction in equities. ' +
		'Overall, we see a positive picture globally and believe a stable growth environment should contribute to the persistent low volatility regime.' +
		'</p><p><b>U.S. Equities:</b> We remain overweight to the IJ.S. relative to other regions but are slightly reducing that overweight. ' +
		'We have seen a strong pickup in earnings momentum globally, and domestic valuations currently do not appear as attractive as their international counterparts. ' +
		'That said, U.S forward earnings may be underestimated, as sell-side analysts have yet to account for potential tax reform. ' +
		'Within the IJ.S. we are maintaining exposure to momentum stocks and believe the expansionary environment should provide a continuing tailwind. ' +
		'</p><p><b>International Developed Equities:</b> We maintain a slight underweight to international developed equities relative to both U.S. and Emerging Market (EM) stocks. ' +
		'Within International Developed, we are shifting towards a larger allocation in currency-hedged equity. ' +
		'However, this should be viewed in the context of the larger portfolio, and the trade aims to simply maintain our current U.S. dollar exposure at the portfolio level.' +
		'</p><p><b>Emerging Market Equities:</b> We have improved our outlook for emerging market equities, moving from a neutral to overweight position. ' +
		'EM equities have shown strong improvement in economic and earnings growth, and substantial current account surpluses. ' +
		'We believe the asset class could benefit disproportionately from an environment of sustained global growth. ' +
		'Additionally, the asset class currently exhibits cheap relative valuations. ' +
		'Dollar positioning elsewhere in the portfolio seeks to mitigate some of the potential downside risk EM may face from rising interest rates and policy normalization.' +
		'</p><p><b>Fixed Income:</b> We continue to maintain a duration underweight across the portfolios, in anticipation of potentially further rises in yields over coming quarters.' +
		' Inflation prints and market prices of inflation are lower than we think they will be on a go forward basis. ' +
		'Within fixed income we are taking some profits from investment grade and dollar EM bonds and moving that money into treasuries, ' +
		'on the back of the uptick yields of recent weeks. The portfolio\'s overall duration underweight remains intact. ' +
		'Note though that, for portfolios with higher equity, duration is close to neutral so that fixed income may act as a potential ballast ' +
		'in portfolios dominated by equity risk.</p>'
};

export const ErrorDCR = {
	OLD_MODEL_ID_ERROR_MESSAGE: 'The analysed model id is not valid. Please select another model.',
	COMMON_ERROR: 'Apologies, we could not process your request.',
	ERROR_RETRY_MESSAGE: 'Please try again.',
	ERROR_RETRY_LABEL: 'Retry',
	UNAUTHORIZED_ERROR: 'Your session is expired, please sign in again to continue',
	ERROR_LOGIN_MESSAGE: 'Please sign in again.',
	ERROR_LOGIN_LABEL: 'Sign In',
	ERROR_CANCEL_LABEL: 'Cancel',
	ERROR_NEW_ANALYSIS_MESSAGE: 'Start New Analysis',
	ERROR_NEW_ANALYSIS_LABEL: 'New Analysis',
	ERROR_GO_TO_PARTNER_LABEL: 'Go to Platform',
	ERROR_CONTINUE_LABEL: 'Continue',
	ERROR_REVIEW_PORTFOLIO_HOLDINGS_MESSAGE: 'Review Portfolio Holdings',
	ERROR_REVIEW_PORTFOLIO_HOLDINGS_LABEL: 'Review Portfolio Holdings',
	ERROR_VIEW_SAVED_PORTFOLIOS_MESSAGE: 'View Saved Portfolios',
	ERROR_VIEW_SAVED_PORTFOLIOS_LABEL: 'View Saved Portfolios',
	ERROR_VIEW_DASHBOARD_LABEL: 'Return to Dashboard',
	ERROR_VIEW_APB_LABEL: 'Close Advisor Center',
	ERROR_FAIL_DIALOG_HEADING: 'Failed!',
	FILTERED_DATA_ERROR_PREFIX: 'The following tickers have been removed from the Advisor Center due to regulatory reasons: ',
	FILTERED_DATA_ERROR_SUFFIX: '.  Please review the portfolio and try again.',
	FILTERED_DATA_ERROR_TITLE: 'The chosen portfolio could not be loaded',
	FILTERED_DATA_ERROR_MESSAGE: 'The following securities are not currently available. Please review the portfolio and update these holdings.',
	MISSING_POSITION_MAPPING_TITLE: 'The chosen portfolio could not be loaded',
	MISSING_POSITION_MAPPING_TITLE_ENGAGEMENT: 'The chosen Portfolio Solutions Engagement could not be loaded',
	MISSING_POSITION_MAPPING_MESSAGE: 'The following securities are not currently available. Please review the portfolio and update these holdings. ',
	MISSING_POSITION_MAPPING_NO_EDIT_MESSAGE: 'The following securities are not currently available. Please select another portfolio to analyse.',
	MISSING_POSITION_MAPPING_MESSAGE_ENGAGEMENT:
		'The following securities are not currently available. Please contact your BlackRock sales representative to refresh the analysis. ',
	MISSING_POSITION_MAPPING_MESSAGE_APB: 'The following securities are not currently available. Please review the portfolios in APB. ',
	NOT_FOUND_OR_UNAUTHORIZED: 'This chosen portfolio could not be found. Please select another portfolio. ',
	ENGAGEMENT_NOT_FOUND_OR_UNAUTHORIZED: 'This chosen engagement ID could not be found.',
	ENGAGEMENT_UPDATE_SAVE_ENGAGEMENT_ERROR_MESSAGE: 'An error occurred while saving your engagement. Please try again later.',
	ENGAGEMENT_UPDATE_ADD_NEW_ENGAGEMENT_ERROR_MESSAGE: 'An error occurred while adding a new engagement. Please try again later.',
	ENGAGEMENT_UPDATE_REMOVE_PORTFOLIO_ERROR_MESSAGE: 'An error occurred while removing a portfolio from your engagements. Please try again later.',
	ENGAGEMENT_UPDATE_EDIT_PORTFOLIO_ERROR_MESSAGE: 'An error occurred while editing your engagement. Please try again later.',
	ENGAGEMENT_UPDATE_CLOSE_CURRENT_ENGAGEMENT_ERROR_MESSAGE: 'An error occurred while closing your engagement. Please try again later.',
	ENGAGEMENT_UPDATE_OPEN_NEW_ENGAGEMENT_ERROR_MESSAGE: 'An error occurred while opening a new engagement. Please try again later.',
	ENGAGEMENT_LOAD_ALL_ERROR_MESSAGE: 'An error occurred while loading all your engagements. Please try again later.',
	ENGAGEMENT_LOAD_ONE_ERROR_MESSAGE: 'An error occurred while loading your engagement. Please try again later.',
	ENGAGEMENT_ADD_ERROR_MESSAGE: 'An error occurred adding a new engagement. Please try again later.',
	ENGAGEMENT_DELETE_PORTFOLIO_ERROR_MESSAGE: 'An error occurred while deleting a portfolio. Please try again later',
	GENERIC_ERROR: 'An error has occurred, please try again soon.',
	GENERAL_CONFIG_ERROR: 'There was a problem obtaining the application configurations.',
	PORTFOLIO_ANALYSER_CONFIG_ERROR: 'There was a problem obtaining the application configurations. Please try again soon.',
	PORTFOLIO_ANALYSIS_COMMON_ERROR: 'Error while retrieving portfolios. Please try again later.',
	SECURITY_DETAILS_COMMON_ERROR: 'Error while retrieving security details. Please try again later.',
	SECURITY_DETAILS_TRANSIENT_ERROR: 'Error while retrieving security details. Please try moving the portfolio to \'My Portfolios\' and review the holdings or try again later.',
	USER_DATA_COMMON_ERROR: 'Error while retrieving user data. Please try again later.',
	SOMETHING_WRONG_ERROR_TITLE: 'Something went wrong...',
	PARTNER_NO_PORTFOLIO_ID_ERROR: 'We were unable to perform an analysis on this portfolio. Please try again later.',
	PARTNER_RESPONSE_ERROR: 'Error while retrieving portfolio data from Partner',
	PARTNER_UNAUTHORISED_PORTFOLIO_ACCESS: 'Error while retrieving portfolio due to incorrect authorisation',
	PARTNER_NO_MODEL_LIST_ERROR: 'We were unable to load portfolios from your platform. Please try again later.',
	PARTNER_NO_PROGRAMS_TARGET_RISK_ERROR: 'This functionality is temporarily unavailable. Please try again later.',
	PARTNER_GENERIC_MESSAGE_ERROR: 'This functionality is temporarily unavailable. Please try again later.',
	PARTNER_NO_DATA_FOUND_ERROR: 'No existing data found',
	PARTNER_INVALID_TOKEN_ERROR: 'You have been logged out due to a system error. Please sign-in again from your platform.',
	PARTNER_EXTERNAL_PORTFOLIO_DEEPLINK_INVALID: 'Error while retrieving portfolio due to incorrect authorization',
	PARTNER_EXTERNAL_PORTFOLIO_DEEPLINK_REFRESH_ERROR: 'Error while retrieving portfolio data. Please try again later',
	PARTNER_ACKNOWLEDGEMENT_ERROR: 'Error while obtaining user acknowldegement',
	PARTNER_EXTERNAL_PORTFOLIO_SAVE_API_ERROR: 'Error while retrieving portfolio data. Please try again later',
	UNABLE_TO_CALCULATE_SCENARIO_ERROR_NO_PORTS: 'We are unable to calculate scenario results for one or more of your portfolios.',
	UNABLE_TO_CALCULATE_SCENARIO_ERROR: 'We are unable to calculate scenario results for:',
	UNABLE_TO_CALCULATE_SCENARIO_ACTION_MESSAGE: 'UNABLE_TO_CALCULATE_SCENARIO_ACTION_MESSAGE',
	UNABLE_TO_CALCULATE_SCENARIO_ACTION_LABEL: 'Proceed to Results',
	ERROR_PORTFOLIO_SERIALIZATION_LIMIT: 'You have more than 200 securities. Please reduce the amount of securities and try again.',
	START_AGAIN_LABEL: 'New Analysis',
	HOLDING_WEIGHT_ERROR: 'Error while retrieving portfolio due to an issue with its holdings. Please edit the portfolio and try again.',
	FTE_NOT_FOUND_ERROR: 'Error while retrieving transition funds to explore portfolio',
	DEPTH_VIOLATION_TITLE: 'Depth violation detected',
	DEPTH_VIOLATION_MESSAGE: 'Your portfolio has too many levels of nested portfolios',
	DEPTH_VIOLATION_MESSAGE_BEFORE_ANALYSIS: 'The portfolio exceeds the maximum number of levels allowed within the portfolio.',
	IMPACTED_PORTFOLIOS_ERROR_TITLE: 'Parent portfolio data not found',
	IMPACTED_PORTFOLIOS_ERROR_MESSAGE: 'Failed to retrieve parent portfolio information',
	LOAD_ANCESTOR_LEVELS_ERROR_TITLE: 'Parent portfolio data not found',
	LOAD_ANCESTOR_LEVELS_ERROR_MESSAGE: 'Failed to retrieve parent portfolio information',
	CIRCULAR_DEPENDENCY_TITLE: 'Parent portfolio already exists',
	CIRCULAR_DEPENDENCY_MESSAGE: 'This portfolio already exist within the portfolio hierarchy. Please replace or remove before saving.',
	BLEND_LEVEL_ERROR_TITLE: 'Blend Error',
	BLEND_LEVEL_ERROR_MESSAGE: 'This portfolio already has too many levels and cannot be blended again.',
	BLEND_CIRC_ERROR_MESSAGE: 'A portfolio that has been added, already exists in the portfolio tree',
	EXCEL_GENERATE_ERROR_MESSAGE: 'There was an error while downloading the Excel Report',
	PERFORMANCE_DATE_MISALIGNED: 'PERFORMANCE_DATE_MISALIGNED',
	FUND_TAG_MISSING_ID_ERROR: 'FUND_TAG_MISSING_ID_ERROR',
	FUND_STATUS_INTERACTION_MISSING_ID_ERROR: 'FUND_STATUS_INTERACTION_MISSING_ID_ERROR',
	FUND_TAG_API_FAILURE_ERROR: 'FUND_TAG_API_FAILURE_ERROR',
	FUND_STATUS_INTERACTION_API_FAILURE_ERROR: 'FUND_STATUS_INTERACTION_API_FAILURE_ERROR',
	FUND_TAG_LIMIT_EXCEEDED_ERROR: 'FUND_TAG_LIMIT_EXCEEDED_ERROR',
	FUND_STATUS_INTERACTION_LIMIT_EXCEEDED_ERROR: 'FUND_TAG_LIMIT_EXCEEDED_ERROR',
	FUND_TAG_TAGGED_FUND_LIMIT_EXCEEDED_ERROR: 'FUND_TAG_TAGGED_FUND_LIMIT_EXCEEDED_ERROR',
	FUND_STATUS_INTERACTION_FUND_LIMIT_EXCEEDED_ERROR: 'FUND_STATUS_INTERACTION_FUND_LIMIT_EXCEEDED_ERROR',
	FUND_TAG_MISSING_SECONDARY_IDENTIFIERS_ERROR: 'FUND_TAG_MISSING_SECONDARY_IDENTIFIERS_ERROR',
	FUND_STATUS_INTERACTION_MISSING_SECONDARY_IDENTIFIERS_ERROR: 'FUND_STATUS_INTERACTION_MISSING_SECONDARY_IDENTIFIERS_ERROR',
	DOMAIN_ACCESS_NOT_ALLOWED_ERROR: 'Seems like the site access rights are missing',
	MISSING_SECURITY_DETAILS_MESSAGE_APB: 'Some of your engagement portfolios have invalid securities. Please review the portfolios in APB.',
	MISSING_SECURITY_DETAILS_MESSAGE_ENGAGEMENT: 'Some of your engagement portfolios have invalid securities. Please contact your BlackRock sales representative to refresh the analysis.',
	SECURITY_DETAILS_HOLDING_ERROR_DESCRIPTION: 'Some of your portfolios have invalid securities, please review them in portfolio editor:',
	SECURITY_DETAILS_HOLDING_ERROR_DESCRIPTION_WITHOUT_REVIEW: 'Some of your portfolios have invalid securities, please try with some other portfolio'
};

export const ERROR_CODES: any = {
	PORTFOLIO_ANALYSIS_HOLDING_FILTERED: 'PORTFOLIO_ANALYSIS_HOLDING_FILTERED',
	CURRENCY_LIST_ERROR: 'CURRENCY_LIST_ERROR',
	BENCHMARK_LIST_ERROR: 'BENCHMARK_LIST_ERRROR',
	PORTFOLIO_ANALYSIS_HOLDING_NOT_FOUND: 'PORTFOLIO_ANALYSIS_HOLDING_NOT_FOUND',
	SECURITY_NOT_FOUND: 'SECURITY_NOT_FOUND',
	SECURITY_RESOLUTION_FAILURE: 'SECURITY_RESOLUTION_FAILURE',
	MISSING_POSITION_MAPPING: 'MISSING_POSITION_MAPPING',
	NOT_FOUND_OR_UNAUTHORIZED: 'NOT_FOUND_OR_UNAUTHORIZED',
	PORTFOLIO_NOT_FOUND: 'PORTFOLIO_NOT_FOUND',
	INVALID_TOKEN: 'INVALID-TOKEN',
	SERIALIZATION_LIMIT: 'SERIALIZATION_LIMIT',
	DEPTH_VIOLATION: 'DEPTH_VIOLATION',
	CIRCULAR_DEPENDENCY: 'CIRCULAR_DEPENDENCY',
	HOLDINGS_TOTAL_WEIGHT_ERROR: 'HOLDINGS_TOTAL_WEIGHT_ERROR',
	NOT_ALLOWED_DOMAIN: 'NOT_ALLOWED_DOMAIN',
	PAC_ERROR_CODES: {
		ENGAGEMENT_CONFIG_NAME: 'ENGAGEMENTS_CONFIG',
		PARSE_ENGAGEMENT_FAILURE: 'PARSE_ENGAGEMENT_FAILURE',
		ENGAGEMENT_NOT_FOUND_OR_UNAUTHORIZED_ERROR: {
			message: 'ENGAGEMENT_NOT_FOUND_OR_UNAUTHORIZED',
			trackMsg: 'engagementnotfoundorunauthorized'
		},
		UPDATE_SAVE_ENGAGEMENT_ERROR: {
			message: 'ENGAGEMENT_UPDATE_SAVE_ENGAGEMENT_ERROR_MESSAGE',
			trackMsg: 'engagementupdatesaveengagementerror'
		},
		UPDATE_ADD_NEW_ENGAGEMENT_ERROR: {
			message: 'ENGAGEMENT_UPDATE_ADD_NEW_ENGAGEMENT_ERROR_MESSAGE',
			trackMsg: 'engagementupdateaddnewengagementerror'
		},
		UPDATE_REMOVE_PORTFOLIO_ERROR: {
			message: 'ENGAGEMENT_UPDATE_REMOVE_PORTFOLIO_ERROR_MESSAGE',
			trackMsg: 'engagementupdateremoveportfolioerror'
		},
		UPDATE_EDIT_PORTFOLIO_ERROR: {
			message: 'ENGAGEMENT_UPDATE_EDIT_PORTFOLIO_ERROR_MESSAGE',
			trackMsg: 'engagementupdateeditportfolioerror'
		},
		UPDATE_CLOSE_CURRENT_ENGAGEMENT_ERROR: {
			message: 'ENGAGEMENT_UPDATE_CLOSE_CURRENT_ENGAGEMENT_ERROR_MESSAGE',
			trackMsg: 'engagementupdateclosecurrentengagementerror'
		},
		UPDATE_OPEN_NEW_ENGAGEMENT: {
			message: 'ENGAGEMENT_UPDATE_OPEN_NEW_ENGAGEMENT_ERROR_MESSAGE',
			trackMsg: 'engagementupdateopennewengagementerror'
		},
		LOAD_ALL_ERROR: {
			message: 'ENGAGEMENT_LOAD_ALL_ERROR_MESSAGE',
			trackMsg: 'engagementloadallengagementerror'
		},
		LOAD_ONE_ERROR: {
			message: 'ENGAGEMENT_LOAD_ONE_ERROR_MESSAGE',
			trackMsg: 'engagementloadoneengagementerror'
		},
		ADD_ERROR: {
			message: 'ENGAGEMENT_ADD_ERROR_MESSAGE',
			trackMsg: 'engagementadderror'
		},
		DELETE_PORTFOLIO_ERROR: {
			message: 'ENGAGEMENT_DELETE_PORTFOLIO_ERROR_MESSAGE',
			trackMsg: 'engagementdeleteportfolioerror'
		}
	},
	WWE_CUSTOM_ERROR_CODES: {
		NO_FUNDS_AFTER_FILTERING: 'NO_FUNDS_AFTER_FILTERING'
	},
	EXCEL_GENERATE_ERROR_CODES: {
		EXCEL_GENERATION_ERROR: 'EXCEL_GENERATION_ERROR',
		BAD_REQUEST_INVALID_PARAMS: 'BAD_REQUEST_INVALID_PARAMS'
	},
	MAX_PORTFOLIOS_LIMIT_ERROR: 'MAX_PORTFOLIOS_LIMIT_ERROR'
};

export const ERROR_SEVERITY_TO_TRACK = 'warning,error,critical';

export const ERROR_SEVERITY: any = {
	WARNING: 'warning',
	ERROR: 'error',
	CRITICAL: 'critical'
};

export const PAErrorDCR = {
	PA_COMMON_ERROR: 'Apologies, we could not process your request.',
	PA_RETRY_MESSAGE: 'Please try again.',
	PA_RETRY_LABEL: 'Retry',
	PA_UNAUTHORIZED_ERROR: 'Your session has expired.',
	PA_LOGIN_MESSAGE: 'Please sign in again.',
	PA_LOGIN_LABEL: 'Sign In',
	PA_ERROR_MESSAGE: 'Proceed to review',
	PA_ERROR_LABEL: 'Proceed to review',
	PA_VIEW_SAVED_MESSAGE: 'View saved portfolios',
	PA_VIEW_SAVED_LABEL: 'View saved portfolios',
	PA_NEW_ANALYSIS_MESSAGE: 'Start New Analysis',
	PA_NEW_ANALYSIS_LABEL: 'New Analysis',
	PA_FAIL_DIALOG_HEADING: 'Failed!'
};

export const PacErrorDCR = {
	PAC_HOLDING_ERROR_DESCRIPTION: 'Some of your portfolios have invalid securities, please review them in portfolio editor:',
	PAC_SECURITY_ERROR_DESCRIPTION: 'Some of your portfolios have invalid securities, please review them in portfolio editor.',
	PAC_RETRY_LABEL: 'Retry',
	PAC_VIEW_ENGAGEMENT: 'View Engagement'
};

export const PcDashboardErrorDCR = {
	PC_HOLDING_ERROR_DESCRIPTION: 'The following portfolio has invalid securities, please review it in portfolio editor:',
	PC_RETRY_LABEL: 'Retry'
};

export const FundProspectusLinksDCR = {
	FUND_PROSPECTUS_BASE_URL: 'http://globaldocuments.morningstar.com/documentlibrary/dochistory.aspx?c=USA&cusip='
};

export const RiskDefaultDCR = {
	RISK_EQUITY: 'Equity',
	RISK_EQUITY_MARKET: 'Equity Market',
	RISK_EQUITY_COUNTRY: 'Equity Country',
	RISK_EQUITY_COUNTRY_NON_US: 'ex-US',
	RISK_UNITED_STATES: 'US',
	RISK_EQUITY_SECTOR: 'Equity Sector',
	RISK_EQUITY_STYLE: 'Equity Style',
	RISK_EQUITY_STYLE_SIZE: 'Size',
	RISK_VOLATILITY: 'Volatility',
	RISK_VALUE: 'Value',
	RISK_GROWTH: 'Growth',
	RISK_MOMENTUM: 'Momentum',
	RISK_DIVIDEND_YIELD: 'Dividend Yield',
	RISK_LEVERAGE: 'Leverage',
	RISK_PROFITABILITY: 'Profitability',
	RISK_EQUITY_STYLE_OTHER: 'Other',
	RISK_SMALLCAP: 'SmallCap',
	RISK_REVERSAL: 'Reversal',
	RISK_LIQUIDITY: 'Liquidity',
	RISK_EARNINGS_YIELD: 'Earnings Yield',
	RISK_SENTIMENT: 'Sentiment',
	RISK_EMERGING: 'Emerging',
	RISK_OIL: 'Oil',
	RISK_IDIOSYNCRATIC: 'Idiosyncratic',
	RISK_FIXED_INCOME: 'Fixed Income',
	RISK_RATES: 'Rates',
	RISK_RATES_INFLATION: 'Inflation',
	RISK_RATES_NON_USD: 'Non US',
	RISK_RATES_USD: 'US',
	RISK_SPREADS: 'Spreads',
	RISK_SPREADS_EM: 'EM',
	RISK_SPREADS_HIGH_YIELD: 'High Yield',
	RISK_SPREADS_INVESTMENT_GRADE: 'IG',
	RISK_SPREADS_LOANS___CREDIT: 'Loan',
	RISK_SPREADS_MUNICIPAL: 'Muni',
	RISK_SPREADS_SECURITIZED: 'Securitized',
	RISK_ALTERNATIVES: 'Alternatives',
	RISK_ALTERNATIVE: 'Alternative',
	RISK_OTHER_ALTERNATIVE: 'Alternative',
	RISK_OTHER_COMMODITY: 'Commodity',
	RISK_FX: 'FX',
	RISK_OTHER: 'Other'
};

export const RiskFullNameDCR = {
	RISK_SPREADS_EM_FULL: 'Emerging Markets',
	RISK_SPREADS_HIGH_YIELD_FULL: 'High Yield',
	RISK_SPREADS_INVESTMENT_GRADE_FULL: 'Investment Grade',
	RISK_SPREADS_LOANS___CREDIT_FULL: 'Loan',
	RISK_SPREADS_MUNICIPAL_FULL: 'Municipal',
	RISK_SPREADS_SECURITIZED_FULL: 'Securitized'
};

export const RiskInsightsDefaultDCR = {
	RISK_INSIGHTS_RISK_LEVEL_1: 'high',
	RISK_INSIGHTS_RISK_LEVEL_2: 'medium',
	RISK_INSIGHTS_RISK_LEVEL_3: 'low',
	RISK_INSIGHTS_BENCHMARK_LEVEL_1: 'significantly',
	RISK_INSIGHTS_BENCHMARK_LEVEL_2: 'moderately',
	RISK_INSIGHTS_BENCHMARK_LEVEL_3: 'slightly',
	RISK_INSIGHTS_BENCHMARK_LEVEL_1_DESC: 'vary from its benchmark significantly',
	RISK_INSIGHTS_BENCHMARK_LEVEL_2_DESC: 'vary from its benchmark moderately',
	RISK_INSIGHTS_BENCHMARK_LEVEL_3_DESC: 'track the benchmark fairly closely',
	RISK_INSIGHTS_DURATION_1: 'longer',
	RISK_INSIGHTS_DURATION_2: 'similar',
	RISK_INSIGHTS_DURATION_3: 'shorter',
	RISK_INSIGHTS_RANGE_1: 'higher',
	RISK_INSIGHTS_RANGE_2: 'similar',
	RISK_INSIGHTS_RANGE_3: 'lower',
	RISK_INSIGHTS_BENCHMARK_VOLATILITY_LEVEL_1: 'meaningfully higher',
	RISK_INSIGHTS_BENCHMARK_VOLATILITY_LEVEL_2: 'modestly higher',
	RISK_INSIGHTS_BENCHMARK_VOLATILITY_LEVEL_3: 'effectively inline',
	RISK_INSIGHTS_BENCHMARK_VOLATILITY_LEVEL_4: 'modestly lower',
	RISK_INSIGHTS_BENCHMARK_VOLATILITY_LEVEL_5: 'meaningfully lower',
	RISK_INSIGHTS_BENCHMARK_VOLATILITY_THAN_DESC: 'than',
	RISK_INSIGHTS_BENCHMARK_VOLATILITY_WITH_DESC: 'with'
};

export const RiskComponentDCR = {
	PDF_TOTAL_RISK_DECOMPOSITION_H3_DESC: 'The type and level of risk in a portfolio helps you understand if the portfolio is aligned with objectives.',
	PDF_ACTIVE_RISK_DECOMPOSITION_H3_DESC: 'The themes that drive performance differences between your portfolio and its benchmark.'
};

export const PDFDataErrorDCR = {
	PDF_DATA_RETRIEVAL_ERROR: 'An error occurred while trying to generate your PDF. Please try again'
};

export const AreasToExploreDcr = {
	ATE_FUND_IDEAS_INSIGHT_TITLE: 'POTENTIAL ${FUND} TO EXPLORE',
	ATE_FUND_IDEAS_OVERVIEW: 'You have <b>${a} ${fund} dragging down your portfolio.</b>',
	ATE_FUND_IDEAS_SUB_TEXT: 'View ${this} ${fund} in the Holdings Details tab.'
};

export const FundIdeasDCR = {
	FTE_COVER_TEXT: 'You have ${a} ${fund} dragging down your portfolio'
};

export const ReplaceAndDeleteDCR = {
	EDIT_AND_DELETE_SUCCESSFUL: 'Portfolio was successfully deleted and replaced in all parents.',
	EDIT_SUCCESSFUL_DELETE_FAILED: 'Edit was successful but delete failed.',
	EDIT_FAILED: 'Failed to edit portfolios. Please try again.'
};

export const ContributionsTooltipDCR = {
	DEFAULT_TOP_CONTRIBUTORS_PATTERN: 'What are the top drivers of ${category}?',
	DEFAULT_TOP_DETRACTORS_PATTERN: 'What are the top detractors of ${category}?',
	DEFAULT_TOP_RISK_CONTRIBUTORS_PATTERN: 'What are the top drivers of ${category} risk?',
	DEFAULT_TOP_RISK_DETRACTORS_PATTERN: 'What are the top detractors of ${category} risk?'
};

export const PeerComparisonGroupDcr = {
	Aggressive: 'Aggressive',
	Moderate: 'Moderate',
	Conservative: 'Conservative',
	ModerateAggressive: 'Moderate Aggressive',
	ModerateConservative: 'Moderate Conservative'
};
